import Vue from "vue";
import Router from "vue-router";
import store from "../../store/store";
import { configService } from "@/settings/api-url";
import { segment_page } from "@/settings/segment";

import General from "@/settings/router/general";
import Auth from "@/settings/router/auth";
import Suscription from "@/settings/router/subscription";

Vue.use(Router);

const routes = [...Auth, ...General, ...Suscription];

const scrollBehavior = (to, from, savedPosition) => {
  if (savedPosition) {
    return savedPosition;
  } else {
    return { x: 0, y: 0 };
  }
};

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior,
});

router.beforeEach(async (to, from, next) => {
  // veirficamos si la url tiene el token
  window.document.title = to.meta && to.meta.title ? to.meta.title : "TodosComemos";
  const queryToken = to.query.origin;
  if (queryToken) {
    // logueamos al usuario
    configService.defaults.headers.common.Authorization = queryToken;
    configService.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
    store.commit("IS_TOKEN", queryToken);
    const name = to.name;
    const query = to.query;
    const params = to.params;
    delete query.origin;
    // dejamos que pase a la ruta que entro con el link magic pero eliminamos el token
    next({ name, params, query });
  } else {
    const getIsToken = store.getters.getIsToken;
    const getCity = store.getters.getCity;
    // revisamos si el usuario esta loguado
    // Si es así inyectamos el token
    if (getIsToken) {
      configService.defaults.headers.common["Authorization"] = getIsToken;
      configService.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
    }
    let openCityModal = true;
    if (!getCity) {
      await store.dispatch("action_getCity", 3);
      openCityModal = false;
    }
    if (!to.name) {
      next({ name: "error-404" });
    } else {
      next();
    }
    store.commit("IS_SELECT_COUNTRY", openCityModal);
    segment_page();
  }
});

export default router;
